import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseValidators } from '@fuse/validators';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { ServiceUsersService } from 'app/services/api/serviceusers/serviceusers.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogServiceUserAddData {
    data: Array<DropDownItem>;
}

@Component({
    selector: 'dialog-settings-serviceusers-add',
    templateUrl: 'dialog-settings-serviceusers-add.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogSettingsServiceUsersAdd extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: UntypedFormGroup;
    submitted = false;
    formEnabled = true;
    passwordMinLength = 16;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogSettingsServiceUsersAdd>,
        private _formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private serviceUsersService: ServiceUsersService,
        private alertsService: AlertsService,
        private translationService: TranslationService,
        @Inject(MAT_DIALOG_DATA) public data: DialogServiceUserAddData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm() {
        this.form = this._formBuilder.group(
            {
                domainId: new FormControl('', [Validators.required]),
                username: new FormControl('', [Validators.required, Validators.minLength(1)]),
                password: new FormControl('', [Validators.required, Validators.minLength(this.passwordMinLength)]),
                confirmPassword: new FormControl('', [Validators.required]),
            },
            {
                validators: FuseValidators.mustMatch('password', 'confirmPassword'),
            }
        );
    }

    onChangeDomain(domainId) {
        this.form.get('domainId').setValue(domainId);
    }

    addServiceUser() {
        if (this.form.invalid) {
            this.alertsService.changealertHeader(this.translationService.translate('info_form_error'));
            this.alertsService.changeAlertErrorMessage(this.translationService.translate('error_form_fill_all_fields'));
            this.alertsService.changeAlertErrorShow(true);
            this.formEnabled = true;
            this.form.enable();
            return;
        }

        this.form.markAllAsTouched();
        this.formEnabled = false;
        this.form.disable();
        this.submitted = true;

        this.serviceUsersService
            .createServiceUser({
                username: this.form.get('username').value,
                password: this.form.get('password').value,
                confirmPassword: this.form.get('confirmPassword').value,
                domainId: this.form.get('domainId').value,
            })
            .subscribe((success) => {
                if (success) {
                    this.dialogRef.close();
                } else {
                    this.formEnabled = true;
                    this.form.enable();
                }
            });
    }
}
